import React, { ReactElement } from 'react'
import { errorUnauthenticatedIcon } from '../../assets/images/images'
import ErrorTemplate from '../templates/ErrorTemplate'

const Error401Unauthenticated = (): ReactElement => {
  return (
    <ErrorTemplate>
      <>
        <div className="mt25">
          <img src={errorUnauthenticatedIcon} className="w8 mb1" alt="error" />
          <h2 className="errorPageTitle">
            Votre dossier est en cours de traitement
          </h2>
          <p className="mt3 mb5 fontWeightBold fontSizeXs lh16">
            Il est possible que nous revenions vers vous après analyse des
            informations transmises. Vous pouvez contacter le 01.44.88.30.05 ou
            votre banquier privé pour toute information complémentaire
          </p>
        </div>
      </>
    </ErrorTemplate>
  )
}

export default Error401Unauthenticated
